import { selectors } from '@admin/app/store/selectors'
import { environment } from '@admin/environments/environment'
import { Injectable } from '@angular/core'
import { isNotNil } from '@engineering11/utility'
import { RestApiClient } from '@engineering11/web-api-rest'
import { Store } from '@ngrx/store'
import { filter, map, Observable } from 'rxjs'

/**
 * Mints a one-time "act as" handoff for a target customer: POSTs to the platform-admin
 * impersonation endpoint and returns the employer URL + code the caller opens in a new tab.
 * Not a CRM concern — surfaced from the platform-admin customer view (see ActAsCustomerComponent).
 */
@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  private api: RestApiClient
  constructor(private store: Store) {
    this.api = new RestApiClient({
      baseUrl: environment.services.platformAdmin,
      token: store.select(selectors.getCurrentToken).pipe(filter(isNotNil)),
    })
  }

  impersonate(targetCustomerKey: string): Observable<{ code: string; employerUrl: string }> {
    return this.api.post<{ code: string; employerUrl: string }>('impersonation', { targetCustomerKey }).pipe(map(res => res.data))
  }
}
